import React from 'react';
import { Mode } from '../constant';

export const useMode = () => {
    const [mode, setMode] = React.useState(Mode.DETAIL);

    const updateMode = (mode: Mode) => {setMode(mode)}
    return {mode, updateMode}
};
